module.exports = __webpack_public_path__ + "media/images/ticket-logic-cf9fc9ee2d64b8f40cf84fc23b19786e.svg";